import React, { useState, useEffect, useRef, useCallback } from 'react';
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import PageHeading from '../../components/pageHeading/PageHeading'
import '../../jobHistory.scss'
import Paginate from '../../components/paginate/Paginate';
import { approveRejectQuote, cancelUserJob, fetchUserIncomingJobs, fetchUserJobListByReqType } from '../../services/auth.service';
import JobContainer from './JobContainer';
import Search from '../../components/search/Search';
import { useDispatch, useSelector } from 'react-redux';
import { setLoader } from '../../slice/commonSlice';
import { toast } from "react-toastify";
import { toast_error, toast_success } from '../../config/Constant';
import { selectUser } from '../../slice/authSlice';
import moment from 'moment';

const JobRequest = () => {
  const [activeTab, setActiveTab] = useState('Incoming');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [jobList, setJobList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const user = useSelector(selectUser);
  const listRef = useRef(null);
  const dispatch = useDispatch();

  const handleTabClick = (index) => {
    setActiveTab(index);
    if (dropdownOpen) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (listRef.current && !listRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(()=>{
    setSearchTerm('');
    setCurrentPage(1);
    if(activeTab === 'Incoming'){
      fetchIncomingJoblist(1);
    } else if(activeTab === 'Outgoing'){
      fetchOutgoingJoblist(1);
    }
  }, [activeTab])


  const fetchOutgoingJoblist = async (page, term = '') => {
    let payload = {
      "userId": user?.id,
      "pageNumber" : page,
      // "search" : term,
      "requestStatus": "pending",
      "resultsPerPage": '5'
    }
    await dispatch(setLoader(true));
    try {
      const response = await fetchUserJobListByReqType(payload);
      await dispatch(setLoader(false));
      let outgoing = response.data?.jobsList?.filter((item)=>item.jobStatus !== "CN");
      setJobList(outgoing);
      setTotalPages(response.data?.totalPages)
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching profile data:", error);
    }
  }

  const fetchIncomingJoblist = async (page, term = '') => {
    let payload = {
      "pageNumber" : page,
      "search" : term,
    }
    await dispatch(setLoader(true));
    try {
      const response = await fetchUserIncomingJobs(payload);
      await dispatch(setLoader(false));
      setJobList(response.data?.jobs);
      setTotalPages(response.data?.totalPages)
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching profile data:", error);
    }
  }

  const updateJobRequest = async (id, status, providerId) => {
    // return
    let payload = {
      "jobId": id,
      "quoteStatus": status,
      "providerId": providerId
    }
    await dispatch(setLoader(true));
    try {
      const response = await approveRejectQuote(payload);
      await dispatch(setLoader(false));
      if(response.status){
        toast.success(response?.data?.message, toast_success)
        fetchIncomingJoblist(currentPage, searchTerm);
      }
    } catch (error) {
      toast.success(error?.data?.message, toast_error)
      await dispatch(setLoader(false));
      console.error("Error fetching profile data:", error);
    }
  }

  const cancelRequest = async (id, providerId, paymentProfileId) => {
    const currentTimestampInSeconds = moment().tz('Atlantic/Bermuda').unix();
    let payload = {
      "jobId": id,
      "timeStamp": currentTimestampInSeconds,
      "providerId": providerId,
      "customerProfileId": user?.userCustomerProfileId,
      "paymentProfileId": paymentProfileId,
    }
    await dispatch(setLoader(true));
    try {
      const response = await cancelUserJob(payload);
      await dispatch(setLoader(false));
      if(response.status){
        toast.success(response?.data?.message, toast_success)
        fetchOutgoingJoblist(currentPage, searchTerm);
      }
    } catch (error) {
      toast.success(error?.data?.message, toast_error)
      await dispatch(setLoader(false));
      console.error("Error fetching profile data:", error);
    }
  }

  const handlePageChange = (page) =>{
    setCurrentPage(page);
    if(activeTab === 'Incoming'){
      fetchIncomingJoblist(page, searchTerm);
    } else if(activeTab === 'Outgoing'){
      fetchOutgoingJoblist(page, searchTerm);
    }
  }

  const handleSearch = useCallback((term) => {
    setSearchTerm(term);
    setCurrentPage(1);
    if(activeTab === 'Incoming'){
      fetchIncomingJoblist(1, term);
    } else if(activeTab === 'Outgoing'){
      fetchOutgoingJoblist(1, term);
    }
  }, [setSearchTerm]);


  return (
    <>
      <Header />
      <PageHeading title="Job Request" />
      <div className='main-container'>
        <div className='container-wrap'>
          <div className='job-history-header'>
            <div className='job-search'>
              <Search setSearchTerm={setSearchTerm} searchTerm={searchTerm}  onSearch={handleSearch} />
            </div>
            <div className='job-nav'>
              <ul>
                <li className={`${activeTab === 'Incoming' ? 'active' : ''}`} onClick={() => handleTabClick('Incoming')}>Incoming</li>
                <li className={`${activeTab === "Outgoing" ? 'active' : ''}`} onClick={() => handleTabClick('Outgoing')}>Outgoing</li>

              </ul>
            </div>
          </div>
          <div className='job-tab-content-wrap'>
            {activeTab === 'Incoming' && <JobContainer type = 'incoming' updateJobRequest={updateJobRequest} list = {jobList} />}
            {activeTab === 'Outgoing' && <JobContainer type = 'outgoing' cancelRequest={cancelRequest} list = {jobList} />}
          </div>
          { jobList?.length > 0 &&
          <Paginate totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            />
          }
        </div>
      </div>
      <Footer />
    </>
  )
}

export default JobRequest
